module.exports = "<li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{match.model}}\">{{match.model}}</li>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/dashboard/tag-typeahead-match.jade
// module id = 305
// module chunks = 0